"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cache_1 = __importDefault(require("@emotion/cache"));
const stylus_plugin_convert_1 = __importDefault(require("./stylus-plugin-convert"));
function default_1() {
    return (0, cache_1.default)({
        key: 'audal',
        stylisPlugins: process.env.NODE_ENV === 'production' ? [
            (0, stylus_plugin_convert_1.default)(),
            // createExtraScopePlugin(`.${uniqueId}`),
        ] : [],
    });
}
exports.default = default_1;
//# sourceMappingURL=create-emotion-cache.js.map